import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=85803ec2"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"
import style0 from "./Information.vue?vue&type=style&index=0&id=85803ec2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports